import React from 'react';
import { Card, CardContent } from './ui/card';

export const Fleet = () => {
  const vehicles = [
    {
      name: 'Maruti Dzire',
      image: 'https://customer-assets.emergentagent.com/job_cab-service-preview/artifacts/w6grghrr_Dzire%20White.avif',
      capacity: '4 Passengers',
      luggage: '3 Bags',
      features: ['AC', 'GPS Tracking', 'Music System'],
      description: 'Comfortable and fuel-efficient sedan, perfect for city rides and airport transfers',
      type: 'Sedan'
    },
    {
      name: 'Toyota Etios',
      image: 'https://customer-assets.emergentagent.com/job_cab-service-preview/artifacts/cbveg4jz_Etios.avif',
      capacity: '4 Passengers',
      luggage: '3 Bags',
      features: ['AC', 'Comfortable Seats', 'Spacious'],
      description: 'Reliable and spacious sedan with excellent comfort for longer journeys',
      type: 'Sedan'
    },
    {
      name: 'Maruti Ertiga',
      image: 'https://customer-assets.emergentagent.com/job_cab-service-preview/artifacts/dzgtk1k2_ertiga.avif',
      capacity: '6-7 Passengers',
      luggage: '4 Bags',
      features: ['Premium AC', 'Extra Space', 'Comfortable Seating'],
      description: 'Spacious and versatile SUV, perfect for family trips and group travel',
      type: 'SUV'
    },
    {
      name: 'Toyota Innova Crysta',
      image: 'https://customer-assets.emergentagent.com/job_cab-service-preview/artifacts/bnsxtqiw_Innova.jpeg',
      capacity: '6-7 Passengers',
      luggage: '5 Bags',
      features: ['Premium AC', 'Luxury Interior', 'Captain Seats'],
      description: 'Premium SUV with superior comfort, ideal for long outstation journeys',
      type: 'Premium SUV'
    }
  ];

  return (
    <section id="fleet" className="py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#d4af37] text-xs font-semibold uppercase tracking-[0.2em]">
              Our Fleet
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-white mb-4 tracking-tight">
            Our Fleet — Sedan &amp; SUV Cabs in Bangalore
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Choose from our range of premium, sanitized vehicles for a comfortable journey
          </p>
        </div>

        {/* Fleet Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {vehicles.map((vehicle) => (
            <Card 
              key={vehicle.name} 
              className="group lux-card rounded-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden flex flex-col h-full"
            >
              {/* Vehicle Image */}
              <div className="relative h-56 overflow-hidden bg-[#1a1a1a] flex-shrink-0">
                <img 
                  src={vehicle.image} 
                  alt={vehicle.name}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <h3 className="font-display text-xl font-semibold text-white">{vehicle.name}</h3>
                  <span className="inline-block mt-1 px-3 py-1 bg-[#d4af37] text-black text-xs font-semibold rounded-full">
                    {vehicle.type}
                  </span>
                </div>
              </div>

              <CardContent className="p-6">
                <p className="text-gray-400 text-sm mb-4">{vehicle.description}</p>
                
                {/* Capacity Info */}
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-white/10">
                  <div className="flex items-center space-x-2">
                    <svg className="w-5 h-5 text-[#d4af37]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span className="text-sm font-medium text-gray-300">{vehicle.capacity}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <svg className="w-5 h-5 text-[#d4af37]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                    <span className="text-sm font-medium text-gray-300">{vehicle.luggage}</span>
                  </div>
                </div>

                {/* Features */}
                <div className="flex flex-wrap gap-2">
                  {vehicle.features.map((feature) => (
                    <span 
                      key={feature}
                      className="px-3 py-1 bg-[#d4af37]/10 text-[#d4af37] text-xs font-medium rounded-full border border-[#d4af37]/20"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <Card className="lux-card rounded-2xl">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-[#d4af37]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="font-display text-lg font-semibold text-white mb-2">Daily Sanitized</h3>
              <p className="text-gray-400 text-sm">All vehicles thoroughly cleaned and sanitized before every ride</p>
            </CardContent>
          </Card>

          <Card className="lux-card rounded-2xl">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-[#d4af37]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="font-display text-lg font-semibold text-white mb-2">Regular Maintenance</h3>
              <p className="text-gray-400 text-sm">Vehicles serviced regularly to ensure peak performance and safety</p>
            </CardContent>
          </Card>

          <Card className="lux-card rounded-2xl">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-[#d4af37]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="font-display text-lg font-semibold text-white mb-2">GPS Enabled</h3>
              <p className="text-gray-400 text-sm">Real-time tracking for your safety and peace of mind</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
